import { render, staticRenderFns } from "./CardProductItem.vue?vue&type=template&id=0b9d2c42&"
import script from "./CardProductItem.vue?vue&type=script&lang=js&"
export * from "./CardProductItem.vue?vue&type=script&lang=js&"
import style0 from "./CardProductItem.vue?vue&type=style&index=0&id=0b9d2c42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports